import { z } from "zod";

export const dogSexSchema = z.enum(["MALE", "FEMALE"]);
export type DogSex = z.infer<typeof dogSexSchema>;

export const dogSizeBucketSchema = z.enum([
    "MINI",
    "SMALL",
    "MEDIUM",
    "LARGE",
    "GIANT",
]);
export type DogSizeBucket = z.infer<typeof dogSizeBucketSchema>;
